import { createStore } from 'redux'
import combineReducers from './combine-reducers'
const reduxStore = createStore(combineReducers)

export default reduxStore
